import { ATRIBUTOS_FILTRO_RELATORIO_ANALITICO, FALTANTE,EXCLUIDO} from './Constants';

const montarQueryFiltro = (filtro_base: string) => {

    let arrayFilterOr = filtro_base ? filtro_base.replaceAll('||','|').replaceAll('&&','&').split('|') : '';
    arrayFilterOr = !arrayFilterOr || !Array.isArray(arrayFilterOr) || arrayFilterOr.length === 0 ? [filtro_base] : arrayFilterOr;
    let arrayFilterOrAnd = [];
        for(let i=0; i< arrayFilterOr.length;i++){
            arrayFilterOrAnd.push(arrayFilterOr[i].split('&'));
        }

    return arrayFilterOrAnd;
}

const isExisteOperadorAnrOr = (filtro_base: string) => {
    return (filtro_base.indexOf('&') !== -1) || (filtro_base.indexOf('|')  !== -1);
}

const montarLinhaParaFilter = (item:any, atributos:string[]) => {
    if(!atributos || atributos.length === 0) return JSON.stringify(item).toLocaleUpperCase();

    let retorno = item[atributos[0]];
    for (let i = 1; i < atributos.length; i++) {
        retorno = `${retorno} ${item[atributos[i]]}`;
    }

    return retorno;
}

const aplicarFiltro = (listaFiltrar: any[], attributosFilter:string[],filtro: string) => {
    let retorno: any[] = [];
    if(!listaFiltrar || !Array.isArray(listaFiltrar) || listaFiltrar.length == 0) return retorno;
    let arrayFiltroOrAnd = montarQueryFiltro(filtro);

    if (!isExisteOperadorAnrOr(filtro)) {
        retorno = listaFiltrar.filter((linha) => {
            let linhaAvaliar = montarLinhaParaFilter(linha,attributosFilter).toLocaleUpperCase();
            //.includes(filtro.toLocaleUpperCase().trim())
            return "URG" !== filtro.trim().toLocaleUpperCase() ? linhaAvaliar.includes(filtro.trim().toLocaleUpperCase()) : linhaAvaliar.includes(filtro.trim().toLocaleUpperCase()) && !linhaAvaliar.includes('NURG');
        });
    } else {

        retorno = listaFiltrar.filter((linha) => {

            let linhaAvaliar = montarLinhaParaFilter(linha,attributosFilter).toLocaleUpperCase();
            let isOk = false;

            for(let i=0;i < arrayFiltroOrAnd.length;i++){
                let and = arrayFiltroOrAnd[i];
                //condição AND
                for(let a=0;a < and.length;a++){

                        if(and[a] && and[a].trim() !== '') isOk = "URG" !== and[a].trim().toLocaleUpperCase() ? linhaAvaliar.includes(and[a].trim().toLocaleUpperCase()) : linhaAvaliar.includes(and[a].trim().toLocaleUpperCase()) && !linhaAvaliar.includes('NURG');
                        //AND -> se tem pelo menos um false não é verdadeiro
                        if(!isOk) break;
                }
               //OR -> se tem pelo menos um true é verdadeiro
                if(isOk) break;

            }

            return isOk;

        });
    }
    return retorno;
}

const montarAtributosRetorioAnalitico = (status:string) => {
    if(status===FALTANTE || status===EXCLUIDO) return [...ATRIBUTOS_FILTRO_RELATORIO_ANALITICO,'dataAlterado'];
    return ATRIBUTOS_FILTRO_RELATORIO_ANALITICO;
}



export {
    aplicarFiltro,
    montarAtributosRetorioAnalitico
}